import { render, staticRenderFns } from "./AssetModelSpecificationsWidgetComponent.vue?vue&type=template&id=396f307d&"
import script from "./AssetModelSpecificationsWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./AssetModelSpecificationsWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports